import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {FinancialManagementService} from '../../../../pages/financial/_services/financial-management.service';
import {FinancialSetting} from '../../../../pages/financial/_models/financial-management.model';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'acabim-admin-onboarding-financial-currency-tax',
  templateUrl: './onboarding-financial-currency-tax.component.html',
  styleUrls: ['../styles.scss', './onboarding-financial-currency-tax.component.scss']
})
export class OnboardingFinancialCurrencyTaxComponent implements OnInit {

  isLoading = false;
  defaultCurrency: { name: string }[] = [];
  taxType: { name: string }[] = [];
  financialForm = new FormGroup({
    currency: new FormControl(null),
    tax: new FormControl(null)
  });

  constructor(
      private readonly financialService: FinancialManagementService,

  ) { }

  ngOnInit(): void {
    this.getPreferences();
  }

  getPreferences(): void {
    this.isLoading = true;
    this.financialService.getTaxType().subscribe(taxData => {
      this.taxType = [];
      taxData.forEach(str => {
        this.taxType.push({name: str});
      });
      this.financialService.getDefaultCurrency().subscribe(currencyData => {
        this.defaultCurrency = [];
        currencyData.forEach(str => {
          this.defaultCurrency.push({name: str});
        });
        this.financialService.getCurrentSettings().subscribe(currentSettingData => {
          this.isLoading = false;
          console.dir(currentSettingData);
          if (this.financialForm && currentSettingData) {
            const currency = this.defaultCurrency.filter(x => x.name === currentSettingData.default_currency)[0];
            this.financialForm.get('currency')?.setValue(currency);
            const tax = this.taxType.filter(x => x.name === currentSettingData.default_tax)[0];
            this.financialForm.get('tax')?.setValue(tax);
          }
        });
      });
    });
  }

  submit(value: boolean) {
    const payload = this.gather();
    this.isLoading = true;
    this.financialService.setCurrentSettings(payload).subscribe(res => {
      this.getPreferences();
    });
  }

  gather(): FinancialSetting {
    return {
      default_currency: this.financialForm.get('currency')?.value?.name,
      default_tax: this.financialForm.get('tax')?.value?.name
    };
  }
}
